import { IsString } from 'class-validator';

export class UpdatePasswordDto {
  @IsString()
  readonly new_password: string;
}